var exports = {
  "a": "xcc377c0b--e669a6--slider",
};

module.exports = exports;
